import type { SVGProps } from 'react'

const LogoBroken = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 21" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.237 16.532c2.023-1.04 2.63-2.15 2.63-2.872 0-.72-.607-1.832-2.63-2.871-1.928-.99-4.717-1.657-7.897-1.657-3.18 0-5.97.666-7.898 1.657-2.023 1.039-2.63 2.15-2.63 2.871 0 .721.607 1.833 2.63 2.872 1.928.99 4.717 1.657 7.898 1.657 3.18 0 5.97-.666 7.897-1.657ZM18.34 20c6.815 0 12.34-2.838 12.34-6.34 0-3.5-5.525-6.34-12.34-6.34C11.525 7.32 6 10.16 6 13.66 6 17.162 11.525 20 18.34 20Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.74 12.948c1.753-1.448 2.109-2.664 1.955-3.368-.154-.704-.986-1.66-3.184-2.242-2.095-.555-4.963-.61-8.07.071-3.106.68-5.689 1.928-7.36 3.308-1.754 1.448-2.11 2.664-1.955 3.368.154.704.985 1.66 3.184 2.242 2.095.556 4.962.61 8.069-.07 3.107-.681 5.689-1.929 7.36-3.309Zm-6.973 5.078c6.657-1.458 11.446-5.413 10.697-8.833-.749-3.42-6.753-5.011-13.41-3.553C5.397 7.098.607 11.052 1.356 14.473c.75 3.42 6.753 5.01 13.41 3.553Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M30.135 15.856c2.26-.245 3.227-1.065 3.485-1.737.259-.673.09-1.929-1.425-3.624-1.445-1.616-3.81-3.239-6.779-4.379-2.969-1.14-5.811-1.519-7.966-1.286-2.261.245-3.227 1.065-3.486 1.737-.258.673-.09 1.93 1.426 3.624 1.445 1.616 3.81 3.239 6.778 4.38 2.97 1.14 5.812 1.518 7.967 1.285Zm-8.616.405c6.362 2.444 12.537 1.776 13.792-1.493 1.256-3.268-2.884-7.899-9.245-10.343-6.362-2.444-12.537-1.775-13.793 1.493-1.255 3.268 2.884 7.9 9.246 10.343Z"
      clipRule="evenodd"
    />
  </svg>
)
export default LogoBroken
